/******************************************************
 *                  Open-iti export
 ********************************************************/

"use strict";

angular.module("exploitation")

	.controller("OpenExportsCtrlParent", [
		"$scope", "OpenExportsService", "Utils", "$uibModal", "toastr", "$location",
		function ($scope, OpenExportsService, Utils, $uibModal, toastr, $location) {

		var deleteModal;
		$scope.data = {};

		/**
		 * Récupérer une classe bootstrap pour l'affichage des cartes correspondant
		 * aux exports en fonction du statut de l'export.
		 * @param status
		 * @returns {string}
		 */
		$scope.getStatusClass = function (status) {
			var statusClass = "";
			switch (status) {
				case "TERMINATED" :
					statusClass = "success";
					break;
				case "ABORTED" :
					statusClass = "danger";
					break;
				case "STARTED" :
					statusClass = "info";
					break;
				default:
					statusClass = "default";
			}
			return statusClass;
		};

		/**
		 * Récupérer un état qui sera affiché
		 * @param status
		 * @returns {string}
		 */
		$scope.getStatusLabel = function (status) {
			var statusLabel = "";
			switch (status) {
				case "OK" :
					statusLabel = "Terminé";
					break;
				case "FAILED" :
					statusLabel = "Erreur";
					break;
				case "STARTED" :
					statusLabel = "En cours";
					break;
				case "PENDING" :
					statusLabel = "Démarré";
					break;
				default:
					statusLabel = "";
			}
			return statusLabel;
		};


		/**
		 * Ouvrir la modal de suppression d'un export.
		 */
		$scope.openDeleteModal = function (exportInfo) {
			$scope.data.exportToDelete = exportInfo;
			deleteModal = Utils.openModal($uibModal, "delete.html", $scope);
		};

		/**
		 * Supprimer un export, notifications, et fermer la modale en cas de succès.
		 * @param export L'export à supprimer.
		 */
		$scope.deleteExport = function (exportInfo) {
			OpenExportsService.deleteExport(exportInfo).then(() => {
				toastr.success("L'export " + exportInfo.action_parameters.name + " a bien été supprimé.", "Export supprimé");
				deleteModal.close();
				if ($scope.data.detailMode) {
					$location.path("/data-management/exports");
				} else {
					OpenExportsService.getAllExports().then((response) => {
						$scope.data.exports = response.data;
					});
				}
			}).catch((error) => {
				const data  = error.data;
				let errorMessage = "Problème lors de la suppression de l'export. ";
				if (data !== undefined && data.message) {
					errorMessage += data.message;
				}
				toastr.error(errorMessage, "Erreur");
			});
		};

		$scope.downloadDataFile = function (exportData) {

			// Récupérer le nom du fichier de données.
			var dataFileName;
			for (var linkIndex in exportData.links) {
				var link = exportData.links[linkIndex];
				if (link.rel === "data") {
					dataFileName = link.href.substr(link.href.lastIndexOf("/") + 1);
					break;
				}
			}

			if (dataFileName !== undefined) {
				OpenExportsService.getExportDataFile(exportData.referential, exportData.id, dataFileName)
					.then((response) => {
						var blob = new Blob([response.data], {type: "octet/stream"});
						var a = document.createElement("a");
						a.href = (window.URL || window.webkitURL).createObjectURL(blob);
						a.target = "_blank";
						a.download = dataFileName;
						document.body.appendChild(a);
						a.click();

					});
			} else {
				toastr.error("Le fichier est introuvable sur le serveur.", "Problème lors du téléchargement");
			}
		};


		/**
		 * Retourner la stat associée à un type d'objet particulier dans le report.
		 * @param type
		 * @returns {*}
		 */
		$scope.getStatForType = function (type) {
			var statObjectList = $scope.data.actionReport.objects.filter(function (obj) {
				return obj.type === type;
			});

			if (statObjectList && statObjectList.length > 0) {
				return statObjectList[0].stats[type];
			} else {
				return 0;
			}
		};

		$scope.downloadValidationReportFile = function (exportData) {

			OpenExportsService.getValidationReport(exportData.events[exportData.events.length - 1].referential, exportData.events[exportData.events.length - 1].chouetteJobId)
				.then((response) => {
					let a = document.createElement("a");
					a.href = "data:text/json;charset=utf-8," + JSON.stringify(response.data);
					a.target = "_blank";
					a.download = "validation_report_" + exportData.fileName + ".json";
					document.body.appendChild(a);
					a.click();
				});
		};

		$scope.downloadValidationReportFileFromExportView = function (exportData) {
			OpenExportsService.getValidationReport(exportData.referential, exportData.id)
				.then((response) => {
					let a = document.createElement("a");
					a.href = "data:text/json;charset=utf-8," + JSON.stringify(response.data);
					a.target = "_blank";
					a.download = "validation_report_" + exportData.action_parameters.name + ".json";
					document.body.appendChild(a);
					a.click();
				})
				.catch(function () {
					toastr.error("Le fichier de validation n'a pas été généré, veuillez consulter le rapport d'action.", "Erreur");
				});
		};

		$scope.downloadActionReportFile = function (exportData) {

			OpenExportsService.getActionReport(exportData.events[exportData.events.length - 1].referential, exportData.events[exportData.events.length - 1].chouetteJobId)
				.then((response) => {
					let a = document.createElement("a");
					a.href = "data:text/json;charset=utf-8," + JSON.stringify(response.data);
					a.target = "_blank";
					a.download = "action_report_" + exportData.fileName + ".json";
					document.body.appendChild(a);
					a.click();
				});
		};

		$scope.downloadActionReportWithoutApiCall = function(data, reportName){
			var a = document.createElement("a");
			a.href = "data:text/json;charset=utf-8," + JSON.stringify(data);
			a.target = "_blank";
			a.download = "action_report_" + reportName + ".json";
			document.body.appendChild(a);
			a.click();
		};

	}]);
